module.exports = __webpack_public_path__ + "assets/img/pdf.f63dfafc.png";